export default {
    type: 'toggle',
    format: {},
    default: {
        logic: 'match',
        value: 'yes'
    },
    setting: {
        logic: []
    },
    options: {
        yes: 'Yes',
        no: 'No'
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Has Play Report',
        category: ['User', 'Plays'],
        description: 'Whether play has a report or not.',
        summarise: {
            template: {
                yes: 'Play has a report',
                no: 'Play does not have a report'
            }
        }
    },
    rules: {
        linked: [],
        legacy: ['play.reports.required']
    }
}